import type { SVGProps } from 'react'
const LineFileText = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M13.56 2H4v20h16V8.44zM14 4.56 17.44 8H14zM5.5 20.5v-17h7v4.75c0 .69.56 1.25 1.25 1.25h4.75v11zM13 16H7.5v1.5H13zm-5.5-3.5h9V14h-9z"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineFileText }
